import React, { useState } from 'react'
import Modal from '../modal/modal'
import CloseSVG from '../../assets/svg/close.svg'
import { useAddPerformanceEvaluation } from '../../redux/human-resources/hook/performance'
import Button from '../button'
import { formatNewDateInWords } from '../../utils/functions'

const AssessmentModal = ({ isOpen, closeModal, assessmentData }) => {
  const {
    mutateAsync: addPerformanceEvaluation,
    isLoading: addPerformanceEvaluationLoading,
  } = useAddPerformanceEvaluation()

  const [grades, setGrades] = useState(() => {
    const criteriaGrades = {}
    assessmentData?.workflow?.sub_workflows?.forEach((criterion) => {
      criteriaGrades[criterion.name] = ''
    })
    return {
      grades: criteriaGrades,
      comment: '',
    }
  })

  const handleInputChange = (e, field) => {
    const value = e.target.value
    const updated = { ...grades }

    const criterion = assessmentData?.workflow?.sub_workflows?.find(
      (c) => c.name === field
    )
    const max = parseFloat(criterion?.max_grade || '0')

    let numeric = parseFloat(value)
    if (isNaN(numeric)) return
    if (numeric > max) numeric = max
    if (numeric < 0) numeric = 0

    updated.grades[field] = numeric.toString()
    setGrades(updated)
  }

  const buildFinalPayload = () => {
    const result = []

    if (!assessmentData?.workflow?.sub_workflows) return null

    for (let c of assessmentData.workflow.sub_workflows) {
      const grade = parseFloat(grades.grades[c.name])
      result.push({
        performance_id: assessmentData.id,
        name: c.name,
        max_grade: c.max_grade,
        grade,
      })
    }

    return {
      result,
    }
  }

  const submitForm = async () => {
    const payload = buildFinalPayload()
    if (!payload) return
    addPerformanceEvaluation(payload).then(() => {
      closeModal()
    })
  }

  const handleInput = (e, field) => {
    let value = e.target.value

    // Remove any non-numeric characters
    value = value.replace(/\D/g, '')

    const criterion = assessmentData?.workflow?.sub_workflows?.find(
      (c) => c.name === field
    )
    const max = parseInt(criterion?.max_grade || '0')

    let numeric = parseInt(value)

    if (isNaN(numeric)) {
      setGrades((prev) => ({
        ...prev,
        grades: { ...prev.grades, [field]: '' },
      }))
    } else {
      if (numeric > max) {
        numeric = max
      }
      setGrades((prev) => ({
        ...prev,
        grades: { ...prev.grades, [field]: numeric.toString() },
      }))
    }
  }

  return (
    <Modal
      scrollable={true}
      className='!max-w-[600px] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <div className='flex flex-col overflow-auto '>
        <div className='flex pt-4 px-4 justify-between'>
          <h2 className='text-center text-lg font-semibold'>
            Provide Feedback About {assessmentData?.first_name}{' '}
            {assessmentData?.last_name}
          </h2>
          <div className='cursor-pointer' onClick={() => closeModal()}>
            <img src={CloseSVG} alt='' />
          </div>
        </div>
        <hr className='divider' />
        <section className='flex flex-col mx-8'>
          <div className='mb-4'>
            <p className='font-medium'>{assessmentData?.first_name}</p>
            <p className='text-sm text-gray-500'>Evaluation Period</p>
            <p className='text-green-600'>
              {formatNewDateInWords(assessmentData.evaluation_start)} -{' '}
              {formatNewDateInWords(assessmentData.evaluation_end)}
            </p>
          </div>

          {assessmentData?.workflow?.sub_workflows?.map((criterion, idx) => (
            <div className='flex flex-col gap-2.5 mb-4' key={idx}>
              <label className='text-sm'>
                Grade {assessmentData.first_name}’s {criterion.name}
              </label>
              <div className='flex gap-4 items-center'>
                <div className='flex flex-col'>
                  <p className='text-black font-bold text-sm'>Maximum grade</p>
                  <p className='text-black text-sm'>{criterion.max_grade}</p>
                </div>
                <div className='flex flex-col'>
                  <p className='text-sm'>Your grade</p>
                  <input
                    type='number'
                    min='0'
                    max={criterion.max_grade}
                    value={grades.grades[criterion.name]}
                    onChange={(e) => handleInputChange(e, criterion.name)}
                    onInput={(e) => handleInput(e, criterion.name)}
                    className='w-[120px] border text-sm rounded p-2 h-10'
                    placeholder='Grade'
                  />
                </div>
              </div>
            </div>
          ))}
          {/* <div className='mb-6'>
            <label className='block mb-1 text-sm'>
              Leave a comment about {employee.name}
            </label>
            <textarea
              value={currentGrade.comment}
              onChange={(e) => handleInputChange(e, 'comment')}
              className='w-full border rounded px-3 py-2'
              placeholder='Write short note.'
            />
          </div> */}

          <div className='flex items-center justify-end mb-2'>
            <Button
              loading={addPerformanceEvaluationLoading}
              className='bg-green-600 text-white'
              onClick={() => submitForm()}
              text='Submit'
              type='button'
            />
          </div>
        </section>
      </div>
    </Modal>
  )
}

export default AssessmentModal
